import { render, staticRenderFns } from "./gerenJL.vue?vue&type=template&id=69c8c364&"
import script from "./gerenJL.vue?vue&type=script&lang=js&"
export * from "./gerenJL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports